(function () {
  if (window.celaSearchReady) return;
  window.celaSearchReady = true;

  function listFor(head) {
    if (!head) return null;
    var el = head.nextElementSibling;
    while (el) {
      if (el.classList && el.classList.contains('predictive-search-results__wrapper-products')) return el;
      var inner = el.querySelector && el.querySelector('.predictive-search-results__wrapper-products');
      if (inner) return inner;
      el = el.nextElementSibling;
    }
    var parent = head.parentElement;
    return parent ? parent.querySelector('.predictive-search-results__wrapper-products') : null;
  }

  function refresh() {
    var heads = document.querySelectorAll('.cela-search-head');
    for (var i = 0; i < heads.length; i++) {
      var nav = heads[i].querySelector('.cela-search-nav');
      if (!nav) continue;
      var list = listFor(heads[i]);
      if (!list) continue;
      list.style.scrollSnapType = 'none';
      if (list.clientWidth === 0) continue;
      nav.style.display = list.scrollWidth > list.clientWidth + 4 ? '' : 'none';
    }
  }

  var timers = [];
  function schedule() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [setTimeout(refresh, 120), setTimeout(refresh, 500), setTimeout(refresh, 1200)];
  }

  function goTo(list, target) {
    try {
      list.scrollTo({ left: target, behavior: 'smooth' });
    } catch (e) {
      list.scrollLeft = target;
    }
    setTimeout(function () {
      if (Math.abs(list.scrollLeft - target) > 2) list.scrollLeft = target;
    }, 420);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cela-search-prev], [data-cela-search-next]');
    if (!button) return;
    event.preventDefault();
    var list = listFor(button.closest('.cela-search-head'));
    if (!list) return;
    list.style.scrollSnapType = 'none';
    var card = list.querySelector('li');
    var step = card ? card.getBoundingClientRect().width + 16 : 220;
    var direction = button.hasAttribute('data-cela-search-next') ? 1 : -1;
    var max = list.scrollWidth - list.clientWidth;
    var target = Math.max(0, Math.min(max, list.scrollLeft + direction * step * 2));
    goTo(list, target);
  });

  document.addEventListener('input', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('animationend', schedule, true);
  window.addEventListener('resize', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
